// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"AppLoader_loaderContainer__x3EGs","pageLoader":"AppLoader_pageLoader__kYu30"};